import styled from 'styled-components';
import { TYPOGRAPHY, COLORS } from '@app/constants';
import { FC, ReactNode } from 'react';
import { BreakpointsEnum } from '@app/types';

interface Props {
  className?: string;
  title?: ReactNode;
  text?: ReactNode;
  img?: ReactNode;
}

const NothingFound: FC<Props> = ({ className, img, title, text }) => {
  return (
    <Root className={className}>
      {img && <ImgWrap>{img}</ImgWrap>}
      <ContentWrap>
        {title && <Title>{title}</Title>}
        {text && <Text>{text}</Text>}
      </ContentWrap>
    </Root>
  );
};

const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImgWrap = styled.div`
  margin-bottom: 24px;
`;

const ContentWrap = styled.div`
  max-width: 333px;
`;

const Title = styled.h3`
  margin-bottom: 8px;
  ${TYPOGRAPHY.heading4Semibold20};
  color: ${COLORS.grayscale700};
  text-align: center;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    ${TYPOGRAPHY.heading4Semibold20};
  }
`;

const Text = styled.p`
  ${TYPOGRAPHY.body1Regular14};
  color: ${COLORS.grayscale600};
  text-align: center;
`;

export default NothingFound;
